import React, { MouseEvent } from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Box, Grid, useTheme } from "@mui/material";

interface ColorSwatchProps {
  fieldKey: string;
  color: string;
  label: string;
  onColorChange: (field: string, event: MouseEvent<HTMLElement>) => void;
}

export const ColorSwatch = ({
  fieldKey,
  color,
  label,
  onColorChange,
}: ColorSwatchProps) => {
  const theme = useTheme();

  return (
    <Grid item key={fieldKey} container alignItems="center" spacing={3}>
      <Grid item>
        <Box
          onClick={(e) => onColorChange(fieldKey, e)}
          sx={{
            width: 24,
            height: 24,
            backgroundColor: color,
            borderRadius: "50%",
            border: `1px solid ${theme.igBorders.core.default}`,
            cursor: "pointer",
            flexShrink: 0,
            "&:hover": {
              transform: "scale(1.1)",
            },
          }}
        />
      </Grid>
      <Grid item sx={{ flex: 1 }}>
        <IgTypography
          variant="body1"
          sx={{ wordWrap: "break-word", overflowWrap: "break-word" }}
        >
          {label}
        </IgTypography>
      </Grid>
    </Grid>
  );
};
